'use strict';

import TinCan from 'tincanjs';
import DownloadFile from './functions/DownloadFile';
import DownloadZip from './functions/DownloadZip';
import Answered from './functions/Answered';
import Attended from './functions/Attended';
import Commented from './functions/Commented';
import End from './functions/End';
import Experienced from './functions/Experienced';
import Failed from './functions/Failed';
import Interacted from './functions/Interacted';
import Navigated from './functions/Navigated';
import Passed from './functions/Passed';
import Progressed from './functions/Progressed';
import Reviewed from './functions/Reviewed';
import Skipped from './functions/Skipped';
import Started from './functions/Started';
import Suspend from './functions/Suspend';
import Suspended from './functions/Suspended';
import Terminated from './functions/Terminated';
import Watched from './functions/Watched';

import defaultconfig from './config/default.json';

export default class XAPIJS
{

    constructor(config, access_token = null)
    {

        if (!config) {
            //test Learning Locker - http://10.100.28.23:9009/organisation/5d229c3d51a271015a3d7ba8/data/source
            config = defaultconfig;
        }
        this.lrs = new TinCan.LRS(config);
        this.access_token = (access_token)? access_token: null;
    }

    /**
     * 下載單個檔案 記錄
     *
     */
    downloadFile(membername, membercode, resource_name, resource_url, file_type)
    {

        this.statement = DownloadFile.statement(membername, membercode, resource_name, resource_url, file_type, this.access_token);

        if (this.statement) {
            this.save(this.statement);
        }
    }

    /**
     * 下載zip的記錄
     *
     */
    downloadZip(membername, membercode, resource_name, resource_url, zipContent)
    {

        this.statement = DownloadZip.statement(membername, membercode, resource_name, resource_url, this.access_token, zipContent);

        if (this.statement) {
            this.save(this.statement);
        }
    }

    answered(membername, membercode, object, objectname)
    {

        this.statement = Answered.statement(membername, membercode, object, this.access_token, objectname);

        if (this.statement) {
            this.save(this.statement);
        }
    }

    attended(membername, membercode, object, objectname)
    {

        this.statement = Attended.statement(membername, membercode, object, this.access_token, objectname);

        if (this.statement) {
            this.save(this.statement);
        }
    }

    commented(membername, membercode, object, objectname)
    {

        this.statement = Commented.statement(membername, membercode, object, this.access_token, objectname);

        if (this.statement) {
            this.save(this.statement);
        }
    }

    end(membername, membercode, object, objectname)
    {

        this.statement = End.statement(membername, membercode, object, this.access_token, objectname);

        if (this.statement) {
            this.save(this.statement);
        }
    }

    experienced(membername, membercode, object, objectname)
    {

        this.statement = Experienced.statement(membername, membercode, object, this.access_token, objectname);

        if (this.statement) {
            this.save(this.statement);
        }
    }

    failed(membername, membercode, object, objectname)
    {

        this.statement = Failed.statement(membername, membercode, object, this.access_token, objectname);

        if (this.statement) {
            this.save(this.statement);
        }
    }

    interacted(membername, membercode, object, objectname)
    {

        this.statement = Interacted.statement(membername, membercode, object, this.access_token, objectname);

        if (this.statement) {
            this.save(this.statement);
        }
    }

    navigated(membername, membercode, object, objectname)
    {

        this.statement = Navigated.statement(membername, membercode, object, this.access_token, objectname);

        if (this.statement) {
            this.save(this.statement);
        }
    }

    passed(membername, membercode, object, objectname)
    {

        this.statement = Passed.statement(membername, membercode, object, this.access_token, objectname);

        if (this.statement) {
            this.save(this.statement);
        }
    }

    progressed(membername, membercode, object, objectname)
    {

        this.statement = Progressed.statement(membername, membercode, object, this.access_token, objectname);

        if (this.statement) {
            this.save(this.statement);
        }
    }

    reviewed(membername, membercode, object, objectname)
    {

        this.statement = Reviewed.statement(membername, membercode, object, this.access_token, objectname);

        if (this.statement) {
            this.save(this.statement);
        }
    }


    skipped(membername, membercode, object, objectname)
    {

        this.statement = Skipped.statement(membername, membercode, object, this.access_token, objectname);

        if (this.statement) {
            this.save(this.statement);
        }
    }

    started(membername, membercode, object, objectname)
    {

        this.statement = Started.statement(membername, membercode, object, this.access_token, objectname);

        if (this.statement) {
            this.save(this.statement);
        }
    }

    suspend(membername, membercode, object, objectname)
    {

        this.statement = Suspend.statement(membername, membercode, object, this.access_token, objectname);

        if (this.statement) {
            this.save(this.statement);
        }
    }

    suspended(membername, membercode, object, objectname)
    {

        this.statement = Suspended.statement(membername, membercode, object, this.access_token, objectname);

        if (this.statement) {
            this.save(this.statement);
        }
    }

    terminated(membername, membercode, object, objectname)
    {

        this.statement = Terminated.statement(membername, membercode, object, this.access_token, objectname);

        if (this.statement) {
            this.save(this.statement);
        }
    }

    watched(membername, membercode, object, objectname)
    {

        this.statement = Watched.statement(membername, membercode, object, this.access_token, objectname);

        if (this.statement) {
            this.save(this.statement);
        }
    }

    /**
     * 處理saveStatement 到 LearningLocker
     * @param statement
     */
    save(statement)
    {
        if (this.lrs) {
            this.lrs.saveStatement(
                statement,
                {
                    //操作
                    callback: function (err, xhr) {
                        //失败后的执行
                        if (err !== null) {
                            if (xhr !== null) {

                                console.log("Failed to save statement: " + xhr.responseText + " (" + xhr.status + ")");
                                // TODO: do something with error, didn't save statement
                                return;
                            }

                            console.log("Failed to save statement: " + err);
                            // TODO: do something with error, didn't save statement
                            return;
                        }
                        //插入成功

                        //此处获取lrs返回会来的UUID（也就是statement的ID）
                        let uuid = xhr.responseURL;
                        if (uuid) uuid = uuid.match(/statementId=([\w|-]*)/)[1];

                    }
                }
            );
        }

    }


}






//////////////////
// WEBPACK FOOTER
// ./node_modules/xapijs/src/index.js
// module id = X+tR
// module chunks = 2 3 4 5 6